<template>

	<div class="landing-privacy">
		<section class="container-fluid" v-in-viewport="" >
			<div class="text-center headline-container">  
		  	 	<h1 class="headline" v-in-viewport="">Privacy Policy</h1>
		 	</div>
			<div v-if="privacy.length" v-html="privacy" class="container block-text">  
		 	</div>
		</section>
	</div>

</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';

	export default{
		name: 'Privacy',
		data () {
		   return {
		   		privacy:[]
		   }
		},
		created(){
			this.getPrivacy();
		},

		mixins:[apiConnection]


	}
</script>


// WEBPACK FOOTER //
// Privacy.vue?8bd501d4